<template>
  <modal v-model="value.show">
    <div slot="content">
      <div class="ls-modal-header">
        <button data-dismiss="modal" close-modal>&times;</button>
        <h4 class="ls-modal-title">{{ $t('taxes.modal.inactive_tax') }}</h4>
      </div>
      <div class="ls-modal-body">
        <div class="ls-alert-warning">
          <strong>{{ $t('application.alert.warning') }}</strong> {{ $t('taxes.modal.inactive_tax_message') }}
        </div>
        <div v-if="tax" v-html="$t('taxes.modal.inactive_message', { tax: tax.name })"></div>
      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn" data-dismiss="modal" close-modal>{{ $t('application.button.close') }}</button>
        <button type="submit" class="ls-btn-danger ls-float-right" @click.prevent="destroyResource()">{{ $t('application.button.inactive') }}</button>
      </div>
    </div>
  </modal>
</template>
<script>
  import Modal from 'src/app/components/shareds/modal/Modal'
  import { mapActions, mapMutations, mapGetters } from 'vuex'

  export default{
    props: ['value'],
    components: { Modal },
    methods: {
      ...mapActions(['inactiveTax']),
      ...mapMutations(['clearFlash']),
      destroyResource () {
        this.clearFlash()
        var params = { 'id': this.tax.id, 'active': false, 'index': this.value.index }
        this.inactiveTax(params).then(this.afterInactivate)
      },
      afterInactivate () {
        this.value.show = false
        if (this.value.callback) this.value.callback()
      }
    },
    computed: {
      ...mapGetters(['tax'])
    }
  }
</script>



// WEBPACK FOOTER //
// ModalInactive.vue?8d803096